"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCoreProcessor = void 0;
/**
 * Create Core processor
 * @param options
 */
var createCoreProcessor = function (_a) {
    var markdownToHTML = _a.markdownToHTML, sanitizer = _a.sanitizer;
    return function (markdown) {
        return sanitizer(markdownToHTML(markdown));
    };
};
exports.createCoreProcessor = createCoreProcessor;
//# sourceMappingURL=core.js.map